import { DeliveryMethod } from 'API';
import { printShippingLabel } from './print.helper';

/**
 * Fetches and prints the shipping label for an order.
 * @param data - An object containing the order number, whether to print the inbound label, and the delivery method type.
 * @returns A Promise that resolves when the shipping label has been printed.
 * @throws An error if there was an issue printing the shipping label.
 */
export const fetchPrintShippingLabel = async (data: {
  orderNumber: string;
  printInboundLabel?: boolean;
  type?: DeliveryMethod | null;
}) => {
  const { orderNumber, printInboundLabel, type } = data;
  // TODO: Should be getting shipping label from subscription payload to pass into below function so we don't have to fetch.
  try {
    await printShippingLabel(orderNumber, printInboundLabel);
  } catch {
    const error = `Error running function to print ${
      type && type === DeliveryMethod.DoctorPickup ? `doctor pickup` : `shipping`
    } label.`;
    console.error(error);
    throw new Error(error);
  }
};
